import React, { useMemo } from "react";
import { FormModal, Form, Field, FormSubmit, AddressFields } from "../form";
import { editUserSchema } from "../../services/users/schemas";

/**
 * Edit a property-buyer user. Parent owns the endpoint; this modal only
 * validates the shape (editUserSchema) and hands the cleaned form data back
 * via onSave. Address fields handled by the reusable AddressFields composite.
 */
const GENDER_OPTIONS = [
  { value: "MALE", label: "Male" },
  { value: "FEMALE", label: "Female" },
];

function EditUserModal({ open, onClose, user, onSave }) {
  const defaultValues = useMemo(
    () => ({
      firstName: user?.firstName || "",
      lastName: user?.lastName || "",
      mobileNoWa: user?.mobileNoWa || "",
      mobileNoCalling: user?.mobileNoCalling || "",
      emailId: user?.emailId || "",
      gender: user?.gender || "",
      dob: user?.dob || "",
      address: {
        buildingNo: user?.address?.buildingNo || "",
        streetName1: user?.address?.streetName1 || "",
        streetName2: user?.address?.streetName2 || "",
        city: user?.address?.city || "",
        district: user?.address?.district || "",
        state: user?.address?.state || "",
        pinCode: user?.address?.pinCode || "",
        country: user?.address?.country || "India",
      },
    }),
    [user],
  );

  const handleSave = async (data) => {
    await onSave?.(data);
    onClose?.();
  };

  return (
    <FormModal open={open} onClose={onClose} title="Edit User" size="xl">
      <Form
        key={user?.id ?? user?.userId ?? "new"}
        schema={editUserSchema}
        defaultValues={defaultValues}
        onSubmit={handleSave}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field name="firstName" label="First Name" required />
          <Field name="lastName" label="Last Name" required />
          <Field name="mobileNoWa" label="WhatsApp Number" type="phone" required />
          <Field name="mobileNoCalling" label="Calling Number" type="phone" required />
          <Field name="emailId" label="Email" type="email" required />
          <Field name="gender" label="Gender" type="select" options={GENDER_OPTIONS} />
          <Field name="dob" label="Date of Birth" type="date" />
        </div>

        <h3 className="text-sm font-semibold text-slate-700 mt-6 mb-2">Address</h3>
        <AddressFields prefix="address" required />

        <FormSubmit>Save</FormSubmit>
      </Form>
    </FormModal>
  );
}

export default EditUserModal;
